import AsyncStorage from '@react-native-async-storage/async-storage'
import React, { useEffect, useState } from 'react'
import { View } from 'react-native'

import { configureStore } from '@reduxjs/toolkit'
import { Provider } from 'react-redux'
import { combineReducers } from 'redux'

import RecipeReducer from './reducers/recipe'
import SettingsReducer from './reducers/settings'
import UserItemReducer from './reducers/user_item_reducer'

const STORAGE_KEY = '@cooked_as'

const CombinedReducer = combineReducers({
  recipes: RecipeReducer,
  settings: SettingsReducer,
  userItems: UserItemReducer,
})

const storeState = (value) =>
  AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(value))

const buildStore = (state) => {
  const store = configureStore({
    reducer: CombinedReducer,
    preloadedState: state,
  })

  const next = store.dispatch

  // Saves the state to async storage after each dispatch
  store.dispatch = (action) => {
    let result = next(action)
    storeState(store.getState())

    return result
  }

  return store
}

// Loads the state from async storage before rendering
const PersistedProvider = ({ children }) => {
  const [loaded, setLoaded] = useState(false)
  const [state, setState] = useState(undefined)

  useEffect(() => {
    AsyncStorage.getItem(STORAGE_KEY).then((value) => {
      setLoaded(true)

      if (value) setState(JSON.parse(value))
    })
  }, [])

  if (!loaded) return <View style={{ flex: 1, backgroundColor: '#162735' }} />

  return <Provider store={buildStore(state)}>{children}</Provider>
}

export default PersistedProvider
